export default {
  loading: false,
  successfulBidders: {
    list: [],
    loading: false
  },
  list: {},
  pagination: {
    items: 0,
    pages: 0
  },
  selectedBidder: {}
};
